import React from 'react';
import './gc.css'; // Import the CSS file

const Gc = ({ items, style }) => {
  return (
    <div className="gc__gallery">
      {items.map((item, index) => (
        <img 
          style={style}
          key={index}
          src={item.imgSrc}
          alt={`Gallery item ${index+1}`}
          className={`gc__gallery-item gc__gallery-item--xs-${item.xs}`}
        />
      ))}
    </div>
  );
}

export default Gc;
